import React, { useEffect, useState } from 'react';
import './UpcomingModal.css';
import { Calendar, ChevronLeft, ChevronRight, X } from 'lucide-react';
import logo from '../../../../assets/logo/VJ-College-logo.png';

const config = require('../../../../config.json');

export default function UpComingView(props) {
  const { eventDetails, handleClose, index, setIndex } = props;
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  if (!eventDetails || eventDetails.length === 0 || index === undefined || !eventDetails[index]) {
    return null;
  }

  const currentEvent = eventDetails[index];
  const story = currentEvent.topStory || {};

  const handleNext = () => {
    if (index + 1 > eventDetails.length - 1) {
      setIndex(0);
    } else {
      setIndex(index + 1);
    }
  };

  const handlePrevious = () => {
    if (index - 1 < 0) {
      setIndex(eventDetails.length - 1);
    } else {
      setIndex(index - 1);
    }
  };

  const eventDate = currentEvent.startDate ? new Date(currentEvent.startDate) : null;
  const formattedDate = eventDate 
    ? eventDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';

  return (
    <div className="vj-modal-box p-3 p-md-4">
      {loaded && (
        <div>
          {/* Modal Header */}
          <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
            <div>
              <div className="vj-modal-badge mb-1">
                <Calendar size={14} />
                <span>{formattedDate || story.timelineHeader || 'Upcoming Event'}</span>
              </div>
              <h3 className="vj-modal-title mb-0">{story.timelineTitle || 'Upcoming Event'}</h3>
            </div>
            <button 
              type="button" 
              className="vj-modal-close-icon"
              onClick={handleClose} 
              aria-label="Close"
              title="Close modal"
            >
              <X size={20} />
            </button>
          </div>

          {/* Full-Width Event Poster / Banner */}
          <div className="vj-modal-img-wrapper mb-3 text-center">
            {story.timelineImage ? (
              <img
                src={`${config.s3.ImageinvokeURL}images/upcomingevents/${story.timelineImage}`}
                alt={story.timelineTitle || 'Event'}
                onError={(e) => { e.target.src = logo; }}
                className="img-fluid rounded-3"
              />
            ) : (
              <div className="p-4 text-center">
                <img src={logo} alt="Vidyajyoti College" style={{ maxWidth: '140px' }} />
              </div>
            )}
          </div>

          {/* Description Text if provided */}
          {story.timelineDescription && story.timelineDescription.trim() !== '' && (
            <div className="vj-modal-desc-box p-3 rounded-3 mb-3 bg-light border">
              <p className="vj-modal-desc mb-0">{story.timelineDescription}</p>
            </div>
          )}

          {/* Modal Navigation Footer */}
          <div className="vj-modal-footer mt-3 pt-3 border-top d-flex justify-content-between align-items-center">
            <div className="d-flex gap-2">
              <button
                type="button"
                className="vj-nav-btn"
                onClick={handlePrevious}
                title="Previous Event"
                disabled={eventDetails.length <= 1}
              >
                <ChevronLeft size={16} /> Prev
              </button>
              <button
                type="button"
                className="vj-nav-btn"
                onClick={handleNext}
                title="Next Event"
                disabled={eventDetails.length <= 1}
              >
                Next <ChevronRight size={16} />
              </button>
            </div>
            <button type="button" className="vj-close-btn" onClick={handleClose}>
              <X size={16} className="me-1" /> Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
